import React, { useEffect, useState } from 'react'
import Modal from 'react-modal';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)', // This sets the overlay color
    zIndex: 2300
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: '720px',
    width: '1000px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const ReceiptPasteModal = ({ isOpen, onRequestClose, onConfirm }) => {
  const [imagePreviews, setImagePreviews] = useState([]);
  const [pastedFiles, setPastedFiles] = useState([]);

  const handlePaste = (event) => {
      if (event.clipboardData && event.clipboardData.items) {
          const items = event.clipboardData.items;
          const newFiles = [];
          const newPreviews = [];

          for (let i = 0; i < items.length; i++) {
              if (items[i].type.indexOf('image') === 0) {
                  const file = items[i].getAsFile();
                  if (file) {
                      newFiles.push(file);

                      const reader = new FileReader();
                      reader.onload = (e) => {
                          newPreviews.push(e.target.result);
                          if (newPreviews.length === newFiles.length) {
                              setImagePreviews((prev) => [...prev, ...newPreviews]);
                              setPastedFiles((prev) => [...prev, ...newFiles]);
                          }
                      };
                      reader.readAsDataURL(file);
                  }
              }
          }
      }
  };

  // Only listen for paste events when modal is open
  useEffect(() => {
      if (isOpen) {
          setImagePreviews([]);
          setPastedFiles([]);
          document.addEventListener('paste', handlePaste);
      }
      return () => {
          document.removeEventListener('paste', handlePaste);
      };
  }, [isOpen]);

  const handleConfirm = () => {
    const filesToSend = [...pastedFiles];
    setImagePreviews([]);
    setPastedFiles([]);
    onConfirm(filesToSend);
    onRequestClose();
  };

  const handleCancel = () => {
    setImagePreviews([]);
    setPastedFiles([]);
    onRequestClose();
  }

  return (
      <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles} ariaHideApp={false}>
          <h2>Paste สลิปที่นี่</h2>
          <div className='flex'>
              {imagePreviews.map((preview, index) => (
                  <img key={index} src={preview} alt={`Pasted ${index}`} style={{ maxWidth: '500px', maxHeight: '500px', margin: '5px' }} />
              ))}
              {!imagePreviews.length && <p>กด Ctrl+V วางรูปได้เลย</p>}
          </div>
          <div className='flex mt-2'>
            <div className='mr-auto'>
              <button className="btn-success bg-indigo-600 hover:bg-indigo-500" onClick={handleConfirm} disabled={!imagePreviews.length}>Confirm</button>
              <button className="btn-danger ml-2" onClick={handleCancel}>Cancel</button>
            </div>
          </div>
      </Modal>
  );
};


export default ReceiptPasteModal